var error = function (part) {
    throw new RangeError("Minimum " + (part ? part + " " : "") + "timeout allowed is 0");
};
/**
 * @internal
 */
export function getTimeout(timeout, appear) {
    var _a, _b, _c;
    if (typeof timeout === "number") {
        if (timeout < 0) {
            error();
        }
        return {
            appear: appear ? timeout : 0,
            enter: timeout,
            exit: timeout,
        };
    }
    var appearTime = (_a = timeout.appear) !== null && _a !== void 0 ? _a : ((appear && timeout.enter) || 0);
    var enter = (_b = timeout.enter) !== null && _b !== void 0 ? _b : 0;
    var exit = (_c = timeout.exit) !== null && _c !== void 0 ? _c : 0;
    if (appearTime < 0 && typeof timeout.appear === "number") {
        error("appear");
    }
    if (enter < 0) {
        error("enter");
    }
    if (exit < 0) {
        error("exit");
    }
    return {
        appear: appearTime,
        enter: enter,
        exit: exit,
    };
}
//# sourceMappingURL=getTimeout.js.map